"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBootstrap = void 0;
var useBootstrap_1 = require("./useBootstrap");
Object.defineProperty(exports, "useBootstrap", { enumerable: true, get: function () { return useBootstrap_1.useBootstrap; } });
